module.exports = __webpack_public_path__ + "img/in-use-amy-rost@2x.27c89fab.jpg";